import React from "react"
import {Link, Redirect} from "react-router-dom";
import Navlink from "./Navlink";
import * as auth from "../../utils/auth";

export default class Sidebar extends React.PureComponent {

  render() {
    return (
        <div style={{backgroundColor: "#38314f", position: "fixed"}}>
          <ul style={{listStyleType: "none", padding: 0}}>
            {auth.is_logged_in() &&
            <React.Fragment>
              <Navlink to="/" text="Home"/>
              <Navlink to="/deposits" text="Deliveries"/>
              <Navlink to="/settings" text="Settings"/>
              <Navlink to="/status" text="Status"/>
            </React.Fragment>
            }
            <Navlink to="/login" text="Login/logout"/>
          </ul>
          {auth.is_logged_in() &&
            <h5 className="ml-2" style={{color: "white"}}>Logged in as {auth.get_name()}</h5>
          }
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js